// Player and team profile pages live under each role's dashboard, so the same
// profile has a different URL for coaches, scouts, and players.
const PROFILE_PATHS = {
  coach: {
    player: (id) => `/coach/player/${id}`,
    team: (id) => `/coach/team/${id}`,
  },
  scout: {
    player: (id) => `/scout/player/${id}`,
    team: (id) => `/scout/team/${id}`,
  },
  player: {
    player: (id) => `/player/profile/${id}`,
    team: (id) => `/player/team/${id}`,
  },
};

// target is { kind: 'player' | 'team', id }. Returns null when the role has no
// profile pages (e.g. admins) or the target has no id.
export const profilePathFor = (role, target) => {
  if (!target?.id) return null;
  const buildPath = PROFILE_PATHS[role]?.[target.kind];
  return buildPath ? buildPath(target.id) : null;
};

// Where a homepage leaderboard click goes. Members open the real profile in
// the app. Everyone else gets the blurred player or team preview, built only
// from the clicked row (`preview`), or sign up when there's nothing to preview.
// The target rides along so logging in afterwards lands on that profile.
export const leaderboardLink = (user, target, preview) => {
  const path = profilePathFor(user?.role, target);
  if (path) return { to: path };
  if (preview && target.id) return { to: `/preview/${target.kind}/${target.id}`, state: preview };
  return { to: '/auth/signup', state: { redirectTo: target } };
};
